export default {
      id: "ic_iddaa_little_finger-usage",
      viewBox: "0 0 31 24",
      url: "/" + "images/icons.3.109.2.svg#ic_iddaa_little_finger-usage",
      toString: function () {
        return this.url;
      }
    }